<template>
<v-navigation-drawer dark temporary v-model="$store.state.main.navigationDrawerRightOpened" right fixed>
    <v-toolbar flat>
        <v-spacer>
            <v-img src="/img/logo.png" width="120"></v-img>
        </v-spacer>
        <v-btn @click.stop="drawerOpenClose()" icon>
            <v-icon>mdi-close</v-icon>
        </v-btn>
    </v-toolbar>

    <v-list dense nav color="cardheaderdark lighten-1" class="userinfo">
        <v-list-item>
            <v-list-item-icon>
                <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-subtitle>Вітаємо,</v-list-item-subtitle>
                <v-list-item-title class="text-break" v-text="userInfo().lastname +' '+userInfo().firstname"></v-list-item-title>
            </v-list-item-content>
        </v-list-item>

        <v-list-item>
            <v-list-item-content>
                <v-list-item-subtitle>Email: <span v-text="userInfo().email"></span></v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>

        <v-list-item>
            <v-list-item-content>
                <v-list-item-subtitle>Тел: <span v-text="userInfo().phone"></span></v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>

        <v-list-item>
            <v-list-item-title class="text-right">ВИЙТИ</v-list-item-title>
            <v-list-item-avatar>
                <v-btn icon @click="logout()">
                    <v-icon>mdi-logout</v-icon>
                </v-btn>
            </v-list-item-avatar>
        </v-list-item>
    </v-list>

    <v-list nav dense v-if="$store.state.main.userInfo && $store.state.main.userInfo.permissions && Object.keys($store.state.main.userInfo.permissions).length > 0">
        <v-list-group color="grey lighten-1" value="true">
            <template v-slot:activator>
                <v-list-item-title class="font-weight-bold">Мої Extraservices</v-list-item-title>
            </template>
            <v-list-item v-if="$store.state.main.userInfo.permissions.megogo" @click="goTo('/megogo')">
                <v-list-item-subtitle class="pl-6">
                    Пакети MEGOGO
                </v-list-item-subtitle>
            </v-list-item>
            <v-list-item v-if="$store.state.main.userInfo.permissions.youtv" @click="goTo('/youtv')">
                <v-list-item-subtitle class="pl-6">
                    Пакети YouTV
                </v-list-item-subtitle>
            </v-list-item>
            <v-list-item @click="goTo('/packagesaleinstructions')">
                <v-list-item-subtitle class="pl-6">
                    Інструкція з продажу пакетів TV
                </v-list-item-subtitle>
            </v-list-item>
        </v-list-group>
    </v-list>

    <v-list nav dense color="grey darken-4" v-if="$store.state.main.referenceList.menuItems && Object.keys($store.state.main.referenceList.menuItems).length > 0">
        <v-list-group color="grey lighten-1" prepend-icon="mdi-account">
            <template v-slot:activator>
                <v-list-item-title>Адмiнiстрування</v-list-item-title>
            </template>
            <v-list-group color="grey lighten-1" sub-group v-for="(item, i) in $store.state.main.referenceList.menuItems" :key="i">
                <template v-slot:activator>
                    <v-list-item-title>{{item}}</v-list-item-title>
                </template>
                <v-list-item v-for="(subItem, idx) in $store.state.main.referenceList.menuSubItems[item]" :key="idx" link color="grey lighten-1" @click="goTo('/adminpanel/'+subItem.route)">
                    <v-list-item-subtitle>
                        {{subItem.name}}
                    </v-list-item-subtitle>
                </v-list-item>
            </v-list-group>
        </v-list-group>
    </v-list>

    <!-- <v-list>
        <v-list-item>
            <v-list-item-title>Test scope</v-list-item-title>
        </v-list-item>
        <v-list-item>
            <v-list-item-title>
                <router-link to="/">Main page</router-link>
            </v-list-item-title>
        </v-list-item>
        <v-list-item>
            <v-list-item-title>
                <router-link to="/login">Login page</router-link>
            </v-list-item-title>
        </v-list-item>
        <v-list-item>
            <v-list-item-title>
                <router-link to="/registration">Registration page</router-link>
            </v-list-item-title>
        </v-list-item>
        <v-list-item>
            <v-list-item-title>
                <router-link to="/megogo">Megogo page</router-link>
            </v-list-item-title>
        </v-list-item>
        <v-list-item>
            <v-list-item-title>
                <router-link to="/megogo/clarification">Megogo Сlarification page</router-link>
            </v-list-item-title>
        </v-list-item>
        <v-list-item>
            <v-list-item-title>
                <router-link to="/adminpanel">Adminpanel</router-link>
            </v-list-item-title>
        </v-list-item>
    </v-list> -->
</v-navigation-drawer>
</template>

<script>
import {
    mapGetters,
    mapActions
} from 'vuex'

export default {
    components: {},
    data: () => ({
        ...mapGetters(['userInfo']),
    }),
    props: {},
    methods: {
        ...mapActions(['logOut']),
        logout: function (params) {
            this.logOut()
                .then(response => {
                    this.$router.push({
                        name: 'login'
                    })
                })
        },
        drawerOpenClose() {
            this.$store.commit('openCloseNavigationDrawerRight', false);
        },
        goTo(url) {
            if (this.$route.path != url) {
                this.$router.push(url)
            }
        }
    },
    created() {}
}
</script>

<style>
.userinfo .v-list-item__action:first-child,
.userinfo .v-list-item__icon:first-child {
    margin-right: 13px !important;
    margin-top: 13px !important;
}
</style>
